import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { activeHint } from '@/composables/useAnchorHint';
export default {
  __name: 'AnchorHintHost',
  setup(__props) {
    const hint = computed(() => activeHint.value);
    const hintStyle = computed(() => {
      const current = hint.value;
      if (!current) return {};
      return {
        position: 'fixed',
        zIndex: 99999,
        top: `${current.top}px`,
        left: `${current.left}px`,
        transform: 'none',
        color: current.color,
        fontSize: current.fontSize,
        fontWeight: current.fontWeight
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "ds-anchor-hint-fade"
      }, {
        default: _withCtx(() => [hint.value ? (_openBlock(), _createElementBlock("span", {
          key: hint.value.id,
          class: "ds-anchor-hint",
          role: "status",
          "aria-live": "polite",
          style: _normalizeStyle(hintStyle.value)
        }, _toDisplayString(hint.value.text), 5)) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }
};